import SDIcon from '../SDIcon'

const IconLineGreen = (props) => (
  <SDIcon viewBox='0 0 54 4' {...props}>
    <rect width='54' height='4' rx='2' fill='#0C8A1E ' />
  </SDIcon>
)

export default IconLineGreen
